import React from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { message, Modal, Progress, Alert } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import SectionHeader from '../../components/SectionHeader'
import SectionHeaderTemplate from '../../components/SectionHeaderTemplate'
import SectionContent from '../../components/SectionContent'
import Spin from '../../components/Spin'
import Form from './Form'
import {
  editForm,
  fetchItem,
  createItem,
  editItem,
  deleteItem,
  reset,
  dismissCvJob,
} from '../../actions/memberForm'

const listPath = '/admin/members'
const itemsTitle = 'Members'
const itemTitle = 'Member'
const storeKey = 'memberForm'

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleFormOnSubmit = this.handleFormOnSubmit.bind(this)
    this.handleFormOnDelete = this.handleFormOnDelete.bind(this)
    this.props.reset()
  }

  componentDidMount() {
    if (this.props.type === 'edit') {
      this.props.fetchItem({ id: this.props.match.params.itemId })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreateItemLoading && nextProps.isCreateItemSuccess) {
      message.success('You have successfully created the item.')
    } else if (this.props.isEditItemLoading && nextProps.isEditItemSuccess) {
      message.success('You have successfully edited the item.')
    } else if (this.props.isDeleteItemLoading && nextProps.isDeleteItemSuccess) {
      message.success('You have successfully deleted the item.')
    } else if (this.props.isCreateItemLoading && nextProps.createItemError) {
      message.error(nextProps.createItemError)
    } else if (this.props.isEditItemLoading && nextProps.editItemError) {
      message.error(nextProps.editItemError)
    } else if (this.props.isDeleteItemLoading && nextProps.deleteItemError) {
      message.error(nextProps.deleteItemError)
    } else if (this.props.isFetchItemLoading && nextProps.fetchItemError) {
      message.error(nextProps.fetchItemError)
    }
  }

  handleFormOnSubmit(values) {
    if (this.props.type === 'create') {
      this.props.createItem(values)
    } else {
      const item = { ...this.props.item, ...values }
      this.props.editItem(item)
    }
  }

  handleFormOnDelete() {
    this.props.deleteItem({ id: this.props.match.params.itemId })
  }

  renderCvJobModal() {
    const { cvJobId, cvJobProgress, cvJobComplete, cvJobTotal, cvJobStatus, cvJobMessage } = this.props
    
    // Show status message modal (storage not configured, no CVs, etc.)
    if (cvJobStatus && !cvJobId) {
      const isWarning = cvJobStatus === 'storage_not_configured' || cvJobStatus === 'no_cvs'
      const isError = cvJobStatus === 'error' || cvJobStatus === 'member_not_found'
      
      return (
        <Modal
          title="CV Generation Status"
          visible={!!cvJobStatus}
          onOk={this.props.dismissCvJob}
          onCancel={this.props.dismissCvJob}
          okText="OK"
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <Alert
            type={isError ? 'error' : isWarning ? 'warning' : 'info'}
            message={cvJobStatus === 'storage_not_configured' ? 'Storage Not Configured' :
                     cvJobStatus === 'no_cvs' ? 'No CVs to Generate' :
                     cvJobStatus === 'member_not_found' ? 'Member Not Found' :
                     cvJobStatus === 'error' ? 'Error' : 'Info'}
            description={cvJobMessage}
            showIcon
          />
        </Modal>
      )
    }
    
    // Show progress modal for active CV generation
    if (!cvJobId) return null

    const progress = cvJobProgress || {}
    const completed = progress.completed || 0
    const total = progress.total || cvJobTotal || 1
    const percent = Math.round((completed / total) * 100)
    const hasErrors = (progress.errors && progress.errors.length > 0) || progress.error
    const isFailed = progress.status === 'failed'
    const isSuccess = cvJobComplete && !isFailed && !hasErrors

    return (
      <Modal
        title="Generating CV PDFs"
        visible={!!cvJobId}
        onOk={this.props.dismissCvJob}
        onCancel={this.props.dismissCvJob}
        okText={cvJobComplete ? 'Done' : 'Run in Background'}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <Progress percent={percent} status={cvJobComplete ? (isFailed || hasErrors ? 'exception' : 'success') : 'active'} />
        <p style={{ marginTop: 16 }}>
          <strong>Status:</strong> {progress.current || 'Starting...'}
        </p>
        <p>
          <strong>Progress:</strong> {completed}/{total} CVs
        </p>
        {isSuccess && (
          <p style={{ color: '#52c41a', fontWeight: 'bold' }}>All CVs generated successfully!</p>
        )}
        {progress.error && (
          <div style={{ marginTop: 16, color: '#ff4d4f' }}>
            <strong>Error:</strong> {progress.error}
          </div>
        )}
        {progress.errors && progress.errors.length > 0 && (
          <div style={{ marginTop: 16, color: '#ff4d4f' }}>
            <strong>Errors:</strong>
            <ul>
              {progress.errors.map((err, i) => (
                <li key={i}>{err}</li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    )
  }

  render() {
    const { type, isCreateItemSuccess, isDeleteItemSuccess } = this.props
    const isCreateForm = type === 'create'
    const actionTitle = isCreateForm ? 'Create' : 'Edit'
    if (isCreateItemSuccess || isDeleteItemSuccess) {
      return <Redirect to={listPath} />
    }
    return (
      <div>
        <AdminLayout>
          <SectionHeader>
            <SectionHeaderTemplate
              breadcrumbRoutes={[{ path: '/admin', title: 'Home' }, { path: listPath, title: itemsTitle }, { title: actionTitle }]}
              title={`${actionTitle} ${itemTitle}`}
            />
          </SectionHeader>
          <SectionContent>
            {
              this.props.isFetchItemLoading && <Spin />
            }
            {
              (isCreateForm || (!isCreateForm && this.props.item)) &&
              <Form
                onSubmit={this.handleFormOnSubmit}
                onDelete={this.handleFormOnDelete}
                onFieldsChange={this.props.editForm}
                formFieldValues={this.props.formFieldValues}
                isCreateItemLoading={this.props.isCreateItemLoading}
                isEditItemLoading={this.props.isEditItemLoading}
                isDeleteItemLoading={this.props.isDeleteItemLoading}
                type={this.props.type}
              />
            }
          </SectionContent>
        </AdminLayout>
        {this.renderCvJobModal()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    formFieldValues,
    isFetchItemLoading,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
    cvJobId,
    cvJobTotal,
    cvJobProgress,
    cvJobComplete,
    cvJobStatus,
    cvJobMessage,
  } = state[storeKey]
  return {
    isFetchItemLoading,
    formFieldValues,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
    cvJobId,
    cvJobTotal,
    cvJobProgress,
    cvJobComplete,
    cvJobStatus,
    cvJobMessage,
  }
}

const mapDispatchToProps = dispatch => ({
  createItem: params => dispatch(createItem(params)),
  editItem: params => dispatch(editItem(params)),
  fetchItem: params => dispatch(fetchItem(params)),
  deleteItem: params => dispatch(deleteItem(params)),
  editForm: formFieldsChange => dispatch(editForm(formFieldsChange)),
  reset: () => dispatch(reset()),
  dismissCvJob: () => dispatch(dismissCvJob()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemForm))
